export default __webpack_public_path__ + "static/media/logowhite.efed085c.png";